import React from "react";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";
import { graphql, useLazyLoadQuery } from "react-relay";
import { FlatList } from "react-native";
import { AHSeparator, ListItem, Circle } from "arkh";
import { ArchivedCalendarsQuery } from "./__generated__/ArchivedCalendarsQuery.graphql";
import { StoreAdminNavigationScreenProps } from "./StoreAdminNavigation";
import { keyExtractorId } from "@/src/common/keyExtractors";

export function ArchivedCalendars(
  props: StoreAdminNavigationScreenProps<"ArchivedCalendars">
) {
  return (
    <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
      {(fetchKey) => <ArchivedCalendars_ {...props} fetchKey={fetchKey} />}
    </LazyQueryNetworkBoundrary>
  );
}

function ArchivedCalendars_(
  props: StoreAdminNavigationScreenProps<"ArchivedCalendars"> & {
    fetchKey: string;
  }
) {
  const data = useLazyLoadQuery<ArchivedCalendarsQuery>(
    graphql`
      query ArchivedCalendarsQuery {
        store {
          archivedCalendars {
            id
            title
            color
          }
        }
      }
    `,
    {},
    {
      fetchKey: props.fetchKey,
      fetchPolicy: "store-and-network",
    }
  );
  return (
    <FlatList
      data={data.store.archivedCalendars}
      keyExtractor={keyExtractorId}
      ItemSeparatorComponent={AHSeparator}
      renderItem={({ item }) => {
        return (
          <ListItem
            left={
              <Circle size="small" style={{ backgroundColor: item.color }} />
            }
            right={<ListItem.NavArrow />}
            onPress={() => {
              props.navigation.navigate("CalendarEdit", {
                calendarId: item.id,
              });
            }}
          >
            <ListItem.Title>{item.title}</ListItem.Title>
          </ListItem>
        );
      }}
    />
  );
}
